import { Typography } from '@material-ui/core'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'

import edvin from '../../../../assets/images/edvin-johansson.png'
import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate } from '../../../../localization'
import { Currency } from '../../../../types/currency'
import useStyles from './styles/index.styles'

type Props = {
  details: {
    price: number
    count: number
  }
  currency: Currency
}

const TotalPrice = ({ details, currency }: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.left}>
        <img src={edvin} className={classes.image} />
        <div className={classes.price}>
          <Typography variant="h6" className={classes.text}>
            {getTranslate('Price')}
          </Typography>
          <Typography variant="h6" className={classes.text}>
            {`${addCommaToPrice(details.price)} ${getTranslate(
              currency || ''
            )}`}
          </Typography>
        </div>
      </div>
      <div className={classes.right}>
        <ShoppingBasketIcon className={classes.icon} />
        <Typography variant="h6" className={classes.redText}>
          {`${details.count} ${getTranslate('Rooms')}`}
        </Typography>
      </div>
    </div>
  )
}

export default TotalPrice
